import { TableSection } from '@/types/table';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';

type TableDialogProps = {
  open: boolean;
  title: string;
  sections: TableSection[];
  onClose: () => void;
};

const TableDialog: React.FC<TableDialogProps> = ({ open, title, sections, onClose }) => {
  return (
    <Dialog open={open} onClose={(reason) => reason !== 'backdropClick' && onClose} maxWidth='md' fullWidth>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box alignSelf='center'>{title}</Box>
        {sections.map((section, sectionIndex) => (
          <Box key={`table-section-${sectionIndex}`}>
            {section.title && (
              <Typography variant='subtitle2' gutterBottom>
                {section.title}
              </Typography>
            )}
            <TableContainer style={{ maxHeight: 300 }}>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    {section.columns.map((column, index) => (
                      <TableCell key={`table-header-${sectionIndex}-${index}`}>{column}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {section.rows.map((row, rowIndex) => (
                    <TableRow key={`table-row-${sectionIndex}-${rowIndex}`}>
                      {row.map((cell, cellIndex) => (
                        <TableCell key={`table-cell-${sectionIndex}-${rowIndex}-${cellIndex}`}>{cell}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TableDialog;
